import { Injectable } from '@angular/core';
import { mimeTypes } from '../constants/mime-type';
import { DbCommon } from '../constants/dbCommon';
import { HelperService } from './helper.service';

@Injectable()
export class FileService {

    private filenameSizeCheckValues: boolean[] = [];
    private sizeCheckValues: boolean[] = [];
    private typeCheckValues: boolean[] = [];
    // public totalFileSize: number = 0;

    constructor(
        private helperService: HelperService,
    ){
    }

    public selectMultipleEvent(files: FileList | File): File[] {
        const fileListArray: File[] = [];
        this.resetChecks();
        // FileList does not have a forEach method
        if (files instanceof FileList) {
            for (let i: number = 0; i < files.length; i++) {
                if (this.doesFileValidate(files[i])) {
                    fileListArray.push(files[i]);
                    // this.totalFileSize += files[i].size;
                }
            }
        } else if (this.doesFileValidate(files)) {
            fileListArray.push(files);
            // this.totalFileSize += files.size;
        }

        return fileListArray;
    }

    // public removeDocument(file: File): void {
    //     this.totalFileSize -= file.size;
    // }

    public checkFileLoadErrors(): string {
        if (this.filenameSizeCheckValues.indexOf(false) !== -1)
            return `File names must be shorter than ${DbCommon.maxFileNameLength} characters.`;

        if (this.sizeCheckValues.indexOf(false) !== -1)
            return 'Files must be smaller than 5MB.';

        if (this.typeCheckValues.indexOf(false) !== -1)
            return 'Please only upload files of the following types: .pdf, .png, .jpg, .jpeg';

        return null;
    }

    public filesToFormData(files: File[]): FormData {
        const l_FormData: FormData = new FormData();
        if (files.length > 1) {
            for (let i: number = 0; i < files.length; i++) {
                this.appendToFormData(l_FormData, 'File', files[i]);
            }
        } else {
            this.appendToFormData(l_FormData, 'File', files[0]);
        }

        return l_FormData;
    }
    
    public convertFileSizeToString(fileSize: number): string {
        if (fileSize === 0) {
            return '0 KB';
        }
        const k = 1024;
        const dm = 2;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(fileSize) / Math.log(k));
        return (fileSize / Math.pow(k, i)).toFixed(dm) + ' ' + sizes[i];
    }

    public appendToFormData(fileListFormData: FormData, propertyName: string, file: any): void {
        return fileListFormData.append(propertyName, file);
    }

    public cancelMultipleEvent(): void {
        this.resetChecks();
    }

    private resetChecks(): void {
        this.typeCheckValues = [];
        this.sizeCheckValues = [];
        this.filenameSizeCheckValues = [];
        // this.totalFileSize = 0;
    }

    private doesFileValidate(file: File): boolean {
        return this.checkFilenameLength(file.name) && this.checkFileType(file.type) && this.checkFileSize(file.size);
    }

    private checkFileType(type: string): boolean {
        let isValid = this.helperService.convertEnumToArray(mimeTypes).some(mimeType => mimeType.value === type);
        this.typeCheckValues.push(isValid);
        return isValid;
    }

    private checkFilenameLength(filename: string): boolean {
        let isValid = filename.length < DbCommon.maxFileNameLength;
        this.filenameSizeCheckValues.push(isValid);
        return isValid;
    }

    private checkFileSize(size: number): boolean {
        let isValid = size < DbCommon.maxFileSize;
        this.sizeCheckValues.push(isValid);
        return isValid;
    }
}